export default class OpsApiError extends Error {
  constructor(error) {
    const fallbackMessage = 'Request failed'
    const message = error?.message || error?.error?.detail || fallbackMessage
    super(message)
    this.name = 'OpsApiError'
    this.originalError = error
    this.status = error?.status || error?.error?.status || null
    this.fieldErrors = this.extractFieldErrors(error)
    this.globalErrors = this.extractGlobalErrors(error)
  }

  extractFieldErrors = (error) => {
    const jsonErrors = error?.json_errors
    if (!Array.isArray(jsonErrors)) {
      return {}
    }

    return jsonErrors.reduce((acc, err) => {
      const field = this.fieldNameForError(err)
      if (!field) {
        return acc
      }
      const detail = err?.detail || err?.title || 'Invalid value'
      if (!acc[field]) {
        acc[field] = []
      }
      acc[field].push(detail)
      return acc
    }, {})
  }

  extractGlobalErrors = (error) => {
    const jsonErrors = error?.json_errors
    if (Array.isArray(jsonErrors) && jsonErrors.length > 0) {
      return jsonErrors
        .filter(err => !this.fieldNameForError(err))
        .map(err => err?.detail || err?.title)
        .filter(Boolean)
    }

    if (error?.message) {
      return [error.message]
    }

    return []
  }

  fieldNameForError = (error) => {
    const parameter = error?.source?.parameter
    if (parameter) {
      return parameter
    }

    const pointer = error?.source?.pointer
    if (!pointer) {
      return null
    }

    const parts = pointer.split('/')
    return parts[parts.length - 1] || null
  }

  firstFieldError = (fieldName) => {
    const fieldErrors = this.fieldErrors[fieldName]
    return fieldErrors && fieldErrors[0] ? fieldErrors[0] : null
  }
}
